import { useEffect, useState } from "react";
import axios from "axios";
import { MapPin } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const headers = () => ({
  headers: { Authorization: `Bearer ${localStorage.getItem("funz_token")}` },
  withCredentials: true,
});

// Simple world map dots (SVG equirectangular projection)
const toXY = (lat, lng) => ({
  x: ((lng + 180) / 360) * 100,
  y: ((90 - lat) / 180) * 100,
});

export const WorldMapSessions = () => {
  const [sessions, setSessions] = useState([]);

  useEffect(() => {
    axios.get(`${API}/admin/enterprise/sessions`, headers()).then((r) => setSessions(r.data.sessions.filter((s) => s.lat != null && s.lng != null))).catch(() => setSessions([]));
  }, []);

  const points = sessions.map((s) => ({ ...s, ...toXY(s.lat, s.lng) }));

  return (
    <section className="rounded-3xl border border-white/10 bg-white/[0.04] p-6 backdrop-blur-xl" data-testid="world-map">
      <p className="flex items-center gap-2 font-display text-lg font-bold"><MapPin className="h-5 w-5 text-[#00D4FF]" /> Admin Sessions — World Map</p>
      <p className="mt-1 text-xs text-slate-500">{points.length} geo-located admin sessions</p>
      <div className="relative mt-4 aspect-[2/1] w-full overflow-hidden rounded-2xl border border-white/10 bg-[#09090B]">
        <svg viewBox="0 0 100 50" className="h-full w-full" preserveAspectRatio="none">
          {/* simplified continents */}
          <path d="M 15 12 Q 22 8 30 12 Q 35 18 30 28 Q 22 35 18 30 Q 12 25 15 12 Z" fill="#1a1a2e" opacity="0.6" />
          <path d="M 32 30 Q 38 32 36 40 Q 32 45 30 40 Q 28 35 32 30 Z" fill="#1a1a2e" opacity="0.6" />
          <path d="M 45 15 Q 55 10 65 15 Q 70 25 65 35 Q 55 40 50 35 Q 42 25 45 15 Z" fill="#1a1a2e" opacity="0.6" />
          <path d="M 68 18 Q 78 15 85 20 Q 88 28 82 35 Q 75 38 70 32 Q 66 25 68 18 Z" fill="#1a1a2e" opacity="0.6" />
          <path d="M 78 38 Q 85 38 88 42 Q 85 46 80 44 Q 76 42 78 38 Z" fill="#1a1a2e" opacity="0.6" />
          {points.map((p, i) => (
            <g key={i}>
              <circle cx={p.x} cy={p.y} r="1.2" fill="#00D4FF" opacity="0.9">
                <animate attributeName="r" values="1.2;2;1.2" dur="2s" repeatCount="indefinite" />
              </circle>
              <circle cx={p.x} cy={p.y} r="2.5" fill="none" stroke="#00D4FF" strokeWidth="0.3" opacity="0.4">
                <animate attributeName="r" values="2.5;4;2.5" dur="2s" repeatCount="indefinite" />
              </circle>
            </g>
          ))}
        </svg>
        {points.length === 0 && (
          <p className="absolute inset-0 flex items-center justify-center text-xs text-slate-500">No geo-located sessions yet — sessions from public IPs will appear here</p>
        )}
      </div>
      {points.length > 0 && (
        <div className="mt-3 flex flex-wrap gap-3">
          {points.map((p, i) => (
            <span key={i} className="flex items-center gap-1.5 font-jbmono text-[10px] text-slate-400">
              <span className="h-1.5 w-1.5 rounded-full bg-[#00D4FF]" /> {p.city || p.country || "Unknown"}
            </span>
          ))}
        </div>
      )}
    </section>
  );
};
